export const MUTATION_GROUP = 'multipleSelectFields' as const;
